import React from "react";
import { DurationHelper } from "commons/Utils/DurationHelper";
import AhoyEvent from "shared/ahoy_event";
import AhoyTracker from "shared/ahoy_tracker";

export default function WatchPlaylistEpisodeCard({ episode, isActive, ahoyProps }) {
  const { attributes: attr } = episode;
  const { links } = episode;

  function sendClickAhoy() {
    const ahoyTitle = "WATCHPAGE";
    let eventTitle = AhoyTracker.getEventTitle(ahoyTitle);
    AhoyEvent.send(eventTitle, ahoyProps);
  }

  return (
    <a href={links.watchpage} style={{ display: "block" }} onClick={sendClickAhoy}>
      <div
        className={
          isActive
            ? "watch-playlist-episode-card watch-playlist-episode-card--active"
            : "watch-playlist-episode-card"
        }
      >
        <div className="watch-playlist-episode-card__image-wrapper">
          <div className="watch-playlist-episode-card__image-placeholder">
            <img
              src={attr.image_url_medium}
              alt={attr.title}
              className="watch-playlist-episode-card__image"
            />
            <span className="watch-playlist-episode-card__duration">
              {DurationHelper(attr.duration).full}
            </span>
          </div>
        </div>

        <div className="watch-playlist-episode-card__title-wrapper">
          <h3 className="watch-playlist-episode-card__title">{attr.title}</h3>
        </div>
      </div>
    </a>
  );
}
